import { Component, Prop } from 'vue-property-decorator';
import { TicketViewmodel } from './ticket.viewmodel';
import { namespace } from 'vuex-class';
import {
  SEARCH_MODULE_NAMESPACE,
  SEARCH_REQUEST_BYKEYS,
  SEARCH_AUTOCOMPLETE
} from '../../../../store/search';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCKS } from '../../../../store/block';
import { IBlock, IBlockParameter } from '../../../../models/block';
import {
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_GET_APPARTMENTS,
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE
} from '../../../../store/apartment';
import { SearchEntities, UserTypes, TicketTypes } from '../../../../common/enums';
import { TENANT_MODULE_NAMESPACE, TENANT_GET_TENANTS, TENANT_GET_BLOCK_TENANTS } from '../../../../store/tenant';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails } from '../../../../models/user';
import { isNullOrUndefined } from 'util';
import { IApartmentListingViewModel } from '../../../../models/apartment';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE);
const TenantStore = namespace(TENANT_MODULE_NAMESPACE);
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
interface IRoundButton {
  key: string;
  value: number | boolean | string;
  translationKey: string;
}

@Component({
  components: {
    'ticket-nature-problem': async () => import('../ticket-modal-nature-of-problem/TicketModalNatureOfProblem.vue'),
    'ticket-upload-buttons': async () => import('../ticket-modal-upload-buttons/TicketUploadButtons.vue'),
    'ticket-group-round-buttons': async () => import('../ticket-modal-group-round-buttons/TicketModalGroupRoundButtons.vue'),
    'ticket-origin-demand': async () => import('../ticket-modal-origin-demand/TicketModalOriginDemand.vue')
  }
})
class TicketModal extends TicketViewmodel {

  private _clearTimeout: any;
  private dtIsManagerOrContractor: boolean;
  private dtPreviousBlockId: number;
  private dtApartments: IApartmentListingViewModel[]
  private dtApartmentLoading: boolean;
  dtRules: {
    ticketDeclarerRules?: any
    nameRules?: any
    ticketFkTicketBlockRules?: any
    ticketFkTicketApartmentRules?: any
    ticketFkTicketTenantRules?: any
    descriptionRules?: any;
    ticketFkTicketCharacterProblemsRules?: any;
    ticketFkTicketManagerRules?: any;
  }
  /**
   *
   */
  constructor() {
    super();
    this.dtRules = {};
    this.dtIsManagerOrContractor = false;
    this.dtPreviousBlockId = null;
    this.dtApartments = [];
    this.dtApartmentLoading = false;
  }

  @UserStore.Getter userInfo: IUserDetails;
  @SearchStore.Getter contractors: any[];
  @SearchStore.Getter managers: any[];
  @SearchStore.Getter caretakers: any[];
  @BlockStore.Getter blocks: any[];
  @TenantStore.Getter tenants: any[];
  @ApartmentStore.Getter apartments: any[];

  @SearchStore.Action(SEARCH_REQUEST_BYKEYS)
  storeGetMasterData: (keys: SearchEntities[]) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { query }) => Promise<any>;

  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetTenantsSearch: (payload: { entity?: SearchEntities | SearchEntities[], query: string }) => Promise<any>;

  @TenantStore.Action(TENANT_GET_TENANTS)
  storeGetTenants: (param: any) => Promise<any>;
  @TenantStore.Action(TENANT_GET_BLOCK_TENANTS)
  storeGetBlockTenants: (payload: { param: any, blockId: string | number }) => Promise<any>;


  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  storeGetAppartments: (payload: { param?: any, blockId: string }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload: { blockId?: string, entity?: string, key?: string }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE)
  storeGetBlockApartmentsAutocomplete: (payload: { blockId?: string, entity?: string, key?: string }) => Promise<any>;
  @Prop({ default: () => [], type: [Array] })
  attachments: any[];
  @Prop({ default: () => [], type: [Array] })
  declarants: any[];

  get coDeclarant() {
    return [this.userInfo];
  }
  get vAttachments() {
    return this.attachments;
  }
  set vAttachments(value) { this.$emit('update:attachments', value); }
  get lblSetting() {
    return {
      ...require('../../../../locales/ticket').default,
      ...require('../../../../locales/validation-messages').default,
    }
  }
  get typesOfTheProblems(): IRoundButton[] {
    const types = [
      { key: 'collective', translationKey: this.lblSetting.ticketTypeOfProblems.public, value: 'public' },
      { key: 'individual', translationKey: this.lblSetting.ticketTypeOfProblems.private, value: 'private' },
    ]
    if (this.dtIsManagerOrContractor) {
      types.push({ key: 'internal', translationKey: this.lblSetting.ticketTypeOfProblems.internal, value: 'internal' })
    }
    return types;
  }
  get notifyTheOwners(): IRoundButton[] {
    return [
      { key: 'OUI', translationKey: 'OUI', value: true },
      { key: 'NON', translationKey: 'NON', value: false },]
  }

  get addASpeakers(): IRoundButton[] {
    return [
      { key: 'DEVIS', translationKey: 'DEVIS', value: false },
      { key: 'MANDATER', translationKey: 'MANDATER', value: true },]
  }
  get coBlocks() {
    return (this.blocks || []).map(
      (b: IBlock) => this.mapBlockToOptions(b).next().value);
  }
  get coApartments() {
    return (this.dtApartments || []).map(x => ({ value: x.apartment.id, text: x.apartment.apartment_number, ...x }));
  }
  get coManagers() {
    return [...(this.managers || []), ...this.dtAssignedMe];
  }
  get coIsManager(): boolean {
    return this.userInfo.type === UserTypes.Manager;
  }
  get coIsAssigned(): boolean {
    return this.Managers.filter(item => item === this.userInfo.id).length > 0
  }
  get coIsPrivate(): boolean {
    return this.pbType === TicketTypes.Private || this.userInfo.type === UserTypes.Tenant;
  }
  get coTenants() {
    return this.dtTemporaryTenants;
  }
  handleGetDeclarants(query: string) {
    return this.storeGetDeclarants({ query })
  }

  handleGetTenants(query: string) {
    return this.storeGetTenantsSearch({ entity: SearchEntities.Tenant, query: query })
  }

  *mapBlockToOptions(block: IBlock) {
    yield { text: block.name, firstname: block.name, lastname: '', value: block.id };
  }
  mounted() {

    this.storeGetMasterData([
      SearchEntities.Contractor,
      SearchEntities.Manager,
      SearchEntities.CareTaker
    ]).catch(error => console.log(error));

    this.$nextTick(() => {
      this.storeGetBlocks({ param: {}, merge: false })
      this.storeGetTenants({}).catch(error => console.log(error))
    })


    this.dtIsMandate = this.ticket.mandates && this.ticket.mandates.length > 0;
    this.dtIsNotifyOwner = this.ticket.mandates && this.ticket.mandates.length > 0;

    this.dtRules = {
      ticketDeclarerRules: [(v) => !!v || this.$t(this.lblSetting.declarererRequired)],
      ticketFkTicketBlockRules: [(v) => (!!v && v > 0) || this.$t(this.lblSetting.declarererRequired)],
      ticketFkTicketApartmentRules: [(v) => !!v || this.$t(this.lblSetting.apartmentRequired)],
      ticketFkTicketTenantRules: [(v) => !!v && (v > 0 || v.id > 0) || this.$t(this.lblSetting.declarererRequired)],
      ticketFkTicketManagerRules: [(v) => !!v && v.length > 0 || this.$t(this.lblSetting.managerRequired)],
      ticketFkTicketCharacterProblemsRules: [(v) => !!v || `${this.$t(this.lblSetting.ticketNatureOfTheProblem)} ${this.$t(this.lblSetting.declarererRequired)}`],
      nameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: 'Name' }),
        v => (!!v && v.length <= 60) || this.$t(this.lblSetting.maxlengthRequired, { length: 60 }),
      ],
      descriptionRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: 'Description' })
      ]
    }

    if (this.userInfo.type === UserTypes.Tenant) {
      this.dtCurrentTenant = JSON.parse(JSON.stringify(this.userInfo));
    }
  }

  handleAssignMe() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      if (this.Managers.filter(id => id === this.userInfo.id).length > 0)
        return;
      this.dtAssignedMe = [{ id: this.userInfo.id, firstname: this.userInfo.firstname, lastname: this.userInfo.lastname }];
      this.storeAssignMe(this.userInfo.id);
    }, 300);
  }

  async bindTenantDefaultData(event: any) {
    this.dtCurrentTenant = event;
    if (event.blocks.length) {
      this.FkTicketBlock = event.blocks.map(x => x.id)[0];
    }
    if (event.apartments.length) {
      this.FkTicketApartment = event.apartments.filter(x => x.fk_apartment_block === this.FkTicketBlock).map(x => x.id)[0];
      this.TicketApartments = event.apartments.filter(x => x.fk_apartment_block === this.FkTicketBlock).map(x => x.id)
    }
  }
  async bindTenantIntoCreator(event) {
    // const isAvailable = this.tenants.filter(t => t.id === this.Declarant); /** Check if creator is available in tanents list */
    // if (isAvailable.length === 0) {
    // }
    this.dtTemporaryTenants = [event];
    this.Tenants = this.Declarant;
  }
  handleChange(event?) {
    if (typeof event === 'number') return;
    if (event && !Array.isArray(event) && typeof event === 'object') {
      this.dtIsManagerOrContractor = event.type === UserTypes.IndependentContractor || event.type === UserTypes.Manager;
      if (this.dtIsManagerOrContractor) {
        this.pbType = TicketTypes.Internal;
        this.dtCurrentTenant = null;
        this.dtTemporaryTenants = [];
        this.Tenants = null;
      } else {
        this.pbType = TicketTypes.Private;
        this.bindTenantDefaultData(event);
        this.bindTenantIntoCreator(event);
      }
    }

    else if (isNullOrUndefined(event)) {
      this.dtIsManagerOrContractor = false;
    }
  }

  handleChangeTenant(event?) {
    if (event && !Array.isArray(event) && typeof event === 'object') {
      this.pbType = TicketTypes.Private;
      if (event.blocks) {
        this.bindTenantDefaultData(event);
      }
      return;
    }
    if (event === undefined) {
      this.dtIsManagerOrContractor = false;
    }
  }

  handleChangeBlock(blockId: any) {
    if (blockId === undefined) {
      this.dtApartments = [];
      return;
    }
    else if (blockId !== this.dtPreviousBlockId && blockId > 0) {
      this.dtApartmentLoading = true;
      this.storeGetBlockTenants({ param: {}, blockId })
        .then(res => {
          this.dtTemporaryTenants = res.data;
          if (this.Tenants && typeof this.Tenants === 'object') {
            if (res.data.filter(x => x.id === (this.Tenants as any).id).length > 0)
              return;
          }
          this.Tenants = res.data[0].id;
        })
        .catch(res => {
          console.log((res))
        })
      this.storeGetAppartments({ blockId: blockId })
        .then(res => {
          this.dtApartments = res.map(x => ({ id: x.apartment.id, fk_apartment_block: x.apartment.fk_apartment_block, apartment: x.apartment }));
          this.dtApartmentLoading = false;
          this.FkTicketApartment = this.dtApartments[0].id;
          this.TicketApartments = this.dtApartments.map(apt => apt.id);
        })
        .catch(err => {
          this.dtApartmentLoading = false;
        })
      this.dtPreviousBlockId = this.FkTicketBlock;
    }

  }

  handleFetchBlocks(key: string, cb: Function) {
    const param: any = { key };
    return this.storeGetBlocks({ param, merge: false }).then(res => {
      return res.map(x => ({ value: x.id, firstname: x.name, lastname: '', text: x.name })) || []
    })
  }
  handleGetApartments(key: string, cb) {
    this.storeGetBlockApartmentsAutocomplete({ blockId: this.FkTicketBlock.toString(), key })
      .then(res => {
        cb((res || []).map(x => ({ value: x.apartment.id, text: x.apartment.apartment_number, ...x })))
      })
      .catch(error => console.log(error))
  }

}

export default TicketModal;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal/index.ts